<template>
  <div>
    <div class="invoice">
      <PageHeader title="فاکتور صورت حساب کالا و خدمات" Class="pb-0" />
      <div class="row" v-if="showPage">
        <div class="col-4 position-relative">
          <Container>
            <DateTimeOffset
              :value="invoiceDate"
              @input="invoiceDate = $event"
              :disable="addCustomerComponent"
              :classes="`mb-3 ${isFormalClass}`"
              title="تاریخ"
              placeholder="تاریخ فاکتور"
            />
            <BaseInput
              @input="invoiceNumber = $event"
              :disable="addCustomerComponent"
              :classes="`${isFormalClass}`"
              :value="invoiceNumber"
              inputType="text"
              title="شماره فاکتور"
              placeholder="شماره فاکتور"
              required
              :showError="invoiceNumberError"
              :errortext="errorText"
            />
          </Container>
          <Container>
            <div v-if="!isFormal">
              <ComboBox
                @loadMoreData="loadMoreCustomerData"
                @searchedItem="searchCustomer($event)"
                :searchedData="customersList"
                @selectedItem="selectCustomer"
                :disabled="addCustomerComponent"
                @buttonAction="openCustomerModal"
                :classes="`${isFormalClass}`"
                :selectedValue="CustomerName"
                :pagination="true"
                :hasButton="true"
                buttonText="+ اضافه کردن خریدار"
                itemClass="__item py-2"
                title="خریدار"
                placeholder="نام و نام خانوادگی"
                invoice
              />
            </div>
            <div v-else>
              <ComboBox
                @loadMoreData="loadMoreCompanyData"
                @searchedItem="searchCompany($event)"
                :searchedData="companyList"
                @selectedItem="selectCompany"
                :disabled="addCustomerComponent"
                @buttonAction="openCompanyModal"
                :classes="`${isFormalClass}`"
                :selectedValue="companyName"
                :pagination="true"
                :hasButton="true"
                buttonText="+ اضافه کردن شرکت"
                itemClass="__item py-2"
                title="شرکت"
                placeholder="شرکت"
                required
                :showError="companyError"
                :errortext="errorText"
              />
              <div style="margin-top: 14px">
                <ComboBox
                  @loadMoreData="loadMoreCustomerData"
                  @searchedItem="searchCustomer($event)"
                  :searchedData="customersList"
                  @selectedItem="selectCustomer"
                  :disabled="addCustomerComponent"
                  @buttonAction="openCustomerModal"
                  :classes="`${isFormalClass}`"
                  :selectedValue="CustomerName"
                  :pagination="true"
                  :hasButton="true"
                  buttonText="+ اضافه کردن رابط"
                  itemClass="__item py-2"
                  title="رابط"
                  placeholder="رابط"
                  invoice
                  required
                  :showError="peopleError"
                  :errortext="errorText"
                />
              </div>
            </div>
          </Container>
          <Container>
            <DateTimeOffset
              :value="invoicePayDate"
              @input="invoicePayDate = $event"
              :disable="addCustomerComponent"
              :classes="`mb-3 ${isFormalClass}`"
              title="تاریخ پرداخت"
              :hasDefaultDate="false"
              clearable
            />
            <TextArea
              @input="description = $event"
              :value="description"
              :disable="addCustomerComponent"
              title="توضیحات"
              placeholder="توضیحات"
              textAreaStyle="height:64px;"
              :textAreaClass="`align-items-center ${isFormalClass}`"
            />
            <b-col cols="12" class="mt-3 fileUploaderDiv" :disable="addCustomerComponent">
              <div
                v-if="images.length === 0"
                class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
                :class="addCustomerComponent ? 'disableUploadFile' : ''"
                @click="!addCustomerComponent ? $bvModal.show('cropperModal') : null"
              >
                <div>
                  <i class="fas fa-cloud-upload-alt icon-size"></i>
                  <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
                </div>
              </div>
              <div v-else class="grand-parent">
                <div class="upload-photo-parent">
                  <div v-for="(source, index) in images" :key="index" class="uploaded-photo">
                    <div class="remove-icon" @click="removeImage({ index, source })">
                      <i class="fa fa-times"></i>
                    </div>
                    <img class="previewImage" :src="source.url" />
                  </div>
                  <div @click="!addCustomerComponent ? $bvModal.show('cropperModal') : null" class="uploaded-photo addNewImageIconContainer">
                    <i class="fa fa-plus"></i>
                  </div>
                </div>
              </div>
            </b-col>
            <b-modal id="cropperModal" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
              <template #modal-title>کراپ عکس</template>
              <div class="p-3">
                <ImageCropper :cropperLoading="mainCropperLoading" @imageSourceChanged="addImageToListOfImages($event)" />
              </div>
            </b-modal>
          </Container>
        </div>
        <div class="col-8">
          <Container>
            <InvoiceTableHeader @toggleFormalInvoice="disable = $event" title="فاکتور صورت حساب کالا و خدمات" />
            <div v-if="!addCustomerComponent">
              <Table fixedHeight v-if="forceUpdateFlag" @listUpdated="listUpdated($event)" />
              <EditableRow @showModal="modal.detail = true" />
              <div class="row">
                <div class="col-6">
                  <TextArea
                    :showTitle="false"
                    @input="note = $event"
                    :value="note"
                    :placeholder="initial ? note : `یادداشت`"
                    textAreaStyle="height:150px;"
                    :textAreaClass="`align-items-center ${isFormalClass}`"
                  />
                </div>
                <div class="col-6">
                  <Receipt @shippmentPrice="shippmentPrice = $event" />
                </div>
                <div class="button-wrapper mt-4">
                  <div
                    @click="
                      modal.cancelInvoice = true
                      flushCustomerState()
                    "
                    class="me-2"
                  >
                    <Button text="انصراف" btnClass="cancel btn-border" />
                  </div>
                  <div @click="submitInvoice"><Button :loading="companyLoading" text="ثبت" btnClass="aprove btn-border" /></div>
                </div>
              </div>
            </div>
            <div v-else>
              <AddCustomer @backToFactor="backToFactor($event)" @changeComponent="addCustomerChangeComponent($event)" @updateCustomerList="updateCustomerListData($event)" />
            </div>
            <Toast :title="toastText" :error="toastMode" :showToast="showToast" />
          </Container>
        </div>
        <b-modal v-model="modalCompany" centered hide-footer body-class="p-0" title="اطلاعات شرکت">
          <div class="p-3">
            <div class="mb-3">
              <BaseInput
                @input="addModalCustomerData.Name = $event"
                :required="true"
                inputType="text"
                title="عنوان شرکت"
                placeholder="عنوان شرکت"
                :showError="companyNameError"
                errortext="وارد کردن عنوان شرکت الزامی است"
              />
            </div>
            <div class="mb-3">
              <BaseInput
                @input="addModalCustomerData.phoneNumber = $event"
                :required="true"
                inputType="number"
                :maxlength="12"
                classes="mt-2"
                title="تلفن"
                placeholder="تلفن"
                :showError="companyPhoneError"
                errortext="وارد کردن تلفن الزامی است"
              />
            </div>
            <div class="mb-3">
              <BaseInput
                @input="addModalCustomerData.economicalNumber = $event"
                :required="true"
                inputType="text"
                classes="mt-2"
                title="شماره اقتصادی"
                placeholder="شماره اقتصادی"
                :showError="companyEconomicNumberError || companyErrShow"
                :errortext="companyEconomicNumberError ? 'وارد کردن شماره اقتصادی الزامی است' : companyErrText"
              />
            </div>
            <div class="mb-3">
              <BaseInput
                @input="addModalCustomerData.nationalRegistrationNumber = $event"
                :required="true"
                inputType="text"
                classes="my-2"
                title="شماره ثبت ملی"
                placeholder="شماره ثبت ملی"
                :showError="companyMelliCodeError"
                errortext="وارد کردن شماره ثبت ملی الزامی است"
              />
            </div>
            <div class="button-wrapper">
              <div
                @click="
                  modalCompany = false
                  companyLoading = false
                "
                class="me-2"
              >
                <Button text="انصراف" btnClass="cancel btn-border" />
              </div>
              <div @click="createCompany">
                <Button :loading="companyLoading" text="ثبت" btnClass="aprove btn-border" />
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal v-model="modal.detail" body-class="p-0" centered hide-footer title="شرح">
          <div class="p-3">
            <ChooseImage :imageCropperModal="imageCropperModal" :cropperLoading="cropperLoading" @productImage="productImage($event)" />
            <BaseInput
              @input="addDetailData.title = $event"
              inputType="text"
              classes="my-3"
              title="عنوان محصول"
              placeholder="عنوان محصول"
              :maxlength="35"
              required
              :showError="addProductErrors.titleError"
              :errortext="addProductErrors.title"
            />
            <Price
              @input="priceNewProduct = $event"
              title="قیمت  (تومان) "
              placeholder="قیمت"
              :value="priceNewProduct"
              required
              :showError="addProductErrors.priceError"
              :errortext="addProductErrors.price"
            />
            <BaseInput
              @input="addDetailData.count = $event"
              inputType="number"
              classes="my-3"
              title="تعداد"
              placeholder="تعداد"
              required
              :showError="addProductErrors.countError"
              :errortext="addProductErrors.count"
            />
            <TextArea
              @input="addDetailData.description = $event"
              inputType="text"
              classes="my-3"
              title="توضیحات"
              placeholder="توضیحات"
              required
              :showError="addProductErrors.descError"
              :errortext="addProductErrors.desc"
            />
          </div>
          <div class="bg">
            <div class="px-3 py-2">
              <b-row class="mb-3" v-for="(property, index) in properties" :key="property">
                <b-col :cols="properties.length > 1 ? '4' : '6'">
                  <BaseInput
                    :value="propertykeys[index]"
                    @enterButton="addNewPropertyField(index)"
                    @input="propertykeys[index] = $event"
                    title="عنوان صفت"
                    placeholder="عنوان صفت"
                    required
                    :showError="addProductErrors.adjError"
                    :errorText="addProductErrors.adj"
                  />
                </b-col>
                <b-col :cols="properties.length > 1 ? '7' : '6'">
                  <BaseInput
                    :value="propertyValues[index]"
                    @input="propertyValues[index] = $event"
                    title="صفت"
                    placeholder="صفت"
                    required
                    :showError="addProductErrors.adjError"
                    :errorText="addProductErrors.adj"
                  />
                </b-col>
                <b-col :cols="properties.length > 1 ? '1' : '0'">
                  <div v-if="properties.length > 1" @click="removePropertyField(index)" class="remove-field-link">
                    <i class="far fa-times-circle"></i>
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-modal v-model="addProductErrors.imgError" centered hide-footer>
              <div class="invoice_error_modal text-center">
                <img class="mb-2" width="70" src="../../assets/images/exclamation.svg" />
                <p>{{ addProductErrors.img }}</p>
              </div>
            </b-modal>
          </div>
          <div class="button-wrapper my-3 px-3">
            <div @click="closeAddProductModal" class="me-2">
              <Button text="انصراف" btnClass="cancel btn-border" />
            </div>
            <div @click="addProduct">
              <Button :loading="productLoading" text="ثبت" btnClass="aprove btn-border" />
            </div>
          </div>
        </b-modal>
        <b-modal v-model="modal.cancelInvoice" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
          <div class="error-wrapper">
            <div class="mb-4">
              <img src="@/assets/images/checked1.svg" />
            </div>
            <div class="error-title">آیا از انصراف خود مطمئن هستید؟</div>
            <div class="buttons">
              <div @click="modal.cancelInvoice = false">
                <button class="cancelButton">خیر</button>
              </div>
              <div @click="backToList">
                <button class="approveButton">بلی</button>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal id="cancelModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
          <!-- <div class="error-wrapper"> -->
          <div class="">
            <div class="mb-4 text-center">
              <img src="@/assets/images/checked1.svg" />
            </div>
            <div class="error-title text-center">موردی برای ثبت نهایی وجود ندارد</div>
            <div class="mt-3 float-right w-100">
              <div class="d-flex align-items-center justify-content-center">
                <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('cancelModal')">انصراف</b-button>
                <b-button class="ms-2 col-6" variant="primary" block @click="$bvModal.hide('cancelModal')">متوجه شدم</b-button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '../../components/layoutComponents/page-header.vue'
import Container from './invoiceInformation/InvoiceInFormationContainer.vue'
import DateTimeOffset from '../common/form/formModules/DateTimeOffset.vue'
import BaseInput from '../common/form/formModules/BaseText.vue'
import Price from '../common/form/formModules/Price.vue'
import TextArea from '../common/form/formModules/TextAreaInput.vue'
import ComboBox from '../common/form/formModules/ComboBox.vue'
import ImageCropper from '../../components/user/ImageCropper.vue'
import InvoiceTableHeader from './invoiceInformation/InvoiceTableHeader.vue'
import Button from '../common/Button.vue'
import ChooseImage from '../common/form/formModules/ChooseImage.vue'
import AddCustomer from './addCustomer/index.vue'
import Table from './table/FactorTable.vue'
import EditableRow from './table/EditableRow.vue'
import Receipt from './invoiceInformation/Receipt.vue'
import { invoiceMixins, searchComboMixins } from '../../utils/mixins'
import invoiceDataProvider from '../../services/invoice'
import moment from 'jalali-moment'
import fileMannager from '../../services/file'
import Toast from '../common/Toast.vue'
export default {
  name: 'invoice',
  mixins: [invoiceMixins, searchComboMixins],
  components: {
    PageHeader,
    Container,
    DateTimeOffset,
    BaseInput,
    TextArea,
    ComboBox,
    ImageCropper,
    InvoiceTableHeader,
    Button,
    ChooseImage,
    AddCustomer,
    Table,
    EditableRow,
    Receipt,
    Price,
    Toast,
  },

  data() {
    return {
      mainCropperLoading: false,
      cropperLoading: false,
      imageCropperModal: false,
      addProductErrors: {
        img: 'بارگذاری عکس الزامیست!',
        imgError: false,
        title: 'وارد کردن عنوان محصول الزامی است',
        titleError: false,
        price: 'وارد کردن قیمت الزامی است',
        priceError: false,
        count: 'وارد کردن تعداد الزامی است',
        countError: false,
        desc: 'وارد کردن توضیحات الزامی است',
        descError: false,
        adj: 'وارد کردن صفت الزامی است',
        adjError: false,
      },
      errorText: 'پر کردن این فیلد الزامیست!',
      companyErrText: '',
      companyErrShow: false,
      peopleError: false,
      companyError: false,
      invoiceNumberError: false,
      companyNameError: false,
      companyPhoneError: false,
      companyEconomicNumberError: false,
      companyMelliCodeError: false,
      showPage: true,
      dommyNumber: 0,
      propertykeys: [],
      propertyValues: [],
      productLoading: false,
      companyLoading: false,
      properties: [0],
      propertiesArray: [],
      allowProductSubmit: true,
      allowCompanySubmit: true,
      allowSubmit: true,
      forceUpdateFlag: true,
      initial: null,
      agentDisable: true,
      invoiceDate: '',
      invoiceNumber: '',
      invoicePayDate: '',
      description: '',
      CustomerName: '',
      CustomerId: null,
      companyId: null,
      note: '',
      fileValue: '',
      images: [],
      removedImages: [],
      disable: false,
      addCustomerComponent: false,
      companyName: null,
      agentName: null,
      shippmentPrice: 0,

      modalCompany: false,
      modal: {
        customer: false,
        detail: false,
        agent: false,
        cancelInvoice: false,
      },
      addModalCustomerData: {
        Name: '',
        phoneNumber: '',
        economicalNumber: '',
        nationalRegistrationNumber: '',
      },
      addDetailData: {
        img: '',
        title: '',
        price: null,
        count: '',
        description: '',
        titleCategory: '',
        category: '',
        isActive: true,
      },
      customerPagination: {
        pageNumber: 1,
        pageSize: 10,
        keyword: '',
      },
      agentPagination: {
        companyId: null,
        pageNumber: 1,
        pageSize: 10,
        keyword: '',
      },
      companyPagination: {
        pageNumber: 1,
        pageSize: 10,
        keyword: '',
      },
      priceNewProduct: '',
      showToast: null,
      toastMode: null,
      toastText: null,
    }
  },
  computed: {
    isFormalClass() {
      if (this.addCustomerComponent) {
        return 'invoice-disable'
      } else {
        return ''
      }
    },
    actionType() {
      if (this.$route.params.id) {
        return true
      } else {
        return false
      }
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
      ]
    },
    eybaba() {
      return this.updateCustomerList
    },
  },
  methods: {
    cancelCreateCompany() {
      this.companyNameError = false
      this.companyPhoneError = false
      this.companyErrShow = false
      this.companyEconomicNumberError = false
      this.companyMelliCodeError = false
    },
    flushCreateCompany() {
      this.cancelCreateCompany()
      this.addModalCustomerData.Name = ''
      this.addModalCustomerData.phoneNumber = ''
      this.addModalCustomerData.economicalNumber = ''
      this.addModalCustomerData.nationalRegistrationNumber = ''
    },
    listUpdated(data) {
      if (data) {
        this.forceUpdateFlag = false
        setTimeout(() => {
          this.forceUpdateFlag = true
        }, 250)
      }
    },
    addNewPropertyField(i) {
      if (i === this.properties.length - 1) {
        this.properties.push(this.dommyNumber++)
      }
    },
    removePropertyField(payload) {
      this.dommyNumber--
      this.properties.splice(payload, 1)
      this.propertyValues.splice(payload, 1)
      this.propertykeys.splice(payload, 1)
    },
    flushCustomerState() {
      this.setSearchedCustomersList()
      this.setCustomersList()
    },
    addCustomerChangeComponent(event) {
      this.addCustomerComponent = event
    },
    updateCustomerListData() {
      this.forceUpdateFlag = false
      this.$nextTick(() => {
        this.getCustomer(this.customerPagination, 1)
        this.forceUpdateFlag = true
      })
    },
    createCompany() {
      this.cancelCreateCompany()
      if (!this.addModalCustomerData.Name) {
        this.companyNameError = true
      }
      if (!this.addModalCustomerData.phoneNumber) {
        this.companyPhoneError = true
      }
      if (!this.addModalCustomerData.economicalNumber) {
        this.companyEconomicNumberError = true
      }
      if (!this.addModalCustomerData.nationalRegistrationNumber) {
        this.companyMelliCodeError = true
        return
      } else {
        if (
          this.addModalCustomerData.Name &&
          this.addModalCustomerData.phoneNumber &&
          this.addModalCustomerData.economicalNumber &&
          this.addModalCustomerData.nationalRegistrationNumber
        ) {
          this.companyLoading = true
          invoiceDataProvider
            .createCompany({
              name: this.addModalCustomerData.Name,
              phoneNumber: this.addModalCustomerData.phoneNumber,
              economicalNumber: this.addModalCustomerData.economicalNumber,
              nationalRegistrationNumber: this.addModalCustomerData.nationalRegistrationNumber,
            })
            .then((res) => {
              this.modalCompany = false
              this.companyLoading = false
              this.getCompanies(this.companyPagination, 2)
              // setTimeout(() => {
              this.companyName = this.addModalCustomerData.Name
              let companyId = res.data.data.companyId
              this.setSelectedCompany({ key: companyId, value: this.companyName })
              // }, 500)
              setTimeout(() => {
                this.addModalCustomerData.Name = ''
                this.addModalCustomerData.phoneNumber = ''
                this.addModalCustomerData.economicalNumber = ''
                this.addModalCustomerData.nationalRegistrationNumber = ''
                this.cancelCreateCompany()
              }, 1000)
            })
            .catch((err) => {
              if (err.response.status == 409) {
                this.companyErrShow = true
                this.companyLoading = false
                this.companyErrText = err.response.data.message
              }
            })
        }
      }
    },
    flushEverything() {
      this.invoiceDate = ''
      this.invoiceNumber = ''
      this.invoicePayDate = ''
      this.description = ''
      this.CustomerName = ''
      this.note = ''
      this.fileValue = ''
      this.images = null
      this.disable = false
      this.addCustomerComponent = false
      this.companyName = null
      this.agentName = null
      this.shippmentPrice = 0
      this.modal.cancelInvoice = true
    },
    backToList() {
      this.flushEverything()
      setTimeout(() => {
        this.$router.push({ path: '/list/invoice' })
      }, 100)
    },
    submitInvoice() {
      this.companyLoading = true
      if (this.invoiceList.length == 0) {
        this.$bvModal.show('cancelModal')
        this.companyLoading = false
        return
      }

      if (!this.actionType) this.addInvoice()
      else this.editInvoice()
    },
    cancelAddinvoiceValidation() {
      this.invoiceNumberError = false
      this.invoiceNoteError = false
      this.companyError = false
      this.peopleError = false
    },
    addInvoice() {
      this.cancelAddinvoiceValidation()
      if (!this.invoiceNumber) {
        this.invoiceNumberError = true
        this.companyLoading = false
      }
      if (!this.selectedCompany && this.isFormal) {
        this.companyError = true
        this.companyLoading = false
      }
      if (!this.selectedCustomer) {
        this.peopleError = true
        this.companyLoading = false
        return
      } else {
        if (this.allowSubmit && this.invoiceNumber && this.selectedCustomer) {
          if (this.invoiceList.length != 0) {
            this.flushErrorFlags()
            const _invoiceList = this.invoiceList
            const _invoiceListItems = _invoiceList.map((_invoice) => _invoice.items)
            const postObj = []
            for (let i = 0; i < _invoiceListItems.length; i++) {
              var count = _invoiceListItems[i].find((e) => e.fieldName === 'Count').value
              var unitPrice = _invoiceListItems[i].find((e) => e.fieldName === 'UnitPrice').value
              var discount = _invoiceListItems[i].find((e) => e.fieldName === 'Discount').value
              var productId = _invoiceListItems[i].find((e) => e.fieldName === 'Product:ProductId').value
              var stockId = _invoiceListItems[i].find((e) => e.fieldName === 'Product:ProductStockId').value
              postObj.push({
                count: parseInt(count),
                unitPrice: parseInt(unitPrice),
                discount: parseInt(discount),
                productId: parseInt(productId),
                stockId: parseInt(stockId),
                propItems: null,
              })
            }
            const createInvoiceData = {
              invoiceNumber: this.invoiceNumber,
              invoiceType: this.isFormal ? 1 : 2,
              companyId: this.isFormal ? this.$store.state.searchCombo.selectedCompany.key : null,
              buyerId: this.$store.state.searchCombo.selectedCustomer.key,
              shippingCost: Number(this.shippmentPrice),
              invoiceDate: moment(this.invoiceDate).format(),
              paymentDate: this.invoicePayDate == '' ? null : moment(this.invoicePayDate).format(),
              description: this.description,
              note: this.note,
              invoiceItem: postObj,
              invoiceImage: this.images,
            }
            this.allowSubmit = false
            invoiceDataProvider
              .addInvoice(createInvoiceData)
              .then((res) => {
                this.$router.push({
                  path: '/list/invoice',
                })
                this.companyLoading = false
                this.flushEverything()
                this.setSelectedCustomer(null)
              })
              .catch((err) => {
                this.allowSubmit = true
                this.companyLoading = false
                this.showServerErrorToast(err.response.status)
              })
          }
        }
      }
    },
    editInvoice() {
      if (this.allowSubmit) {
        if (this.$route.params.id) {
          if (!this.invoiceNumber) {
            this.invoiceNumberError = true
            this.companyLoading = false
          }
          if (!this.selectedCompany && this.isFormal) {
            this.companyError = true
            this.companyLoading = false
          }
          if (!this.selectedCustomer) {
            this.peopleError = true
            this.companyLoading = false
            return
          } else if (this.allowSubmit && this.invoiceNumber && this.selectedCustomer) {
            const postObj = []
            const _invoiceList = this.invoiceList
            const _invoiceListItems = _invoiceList.map((_invoice) => _invoice.items)
            for (let i = 0; i < _invoiceListItems.length; i++) {
              var rowId = _invoiceList[i].id
              var count = _invoiceListItems[i].find((e) => e.fieldName === 'Count').value
              var unitPrice = _invoiceListItems[i].find((e) => e.fieldName === 'UnitPrice').value
              var discount = _invoiceListItems[i].find((e) => e.fieldName === 'Discount').value
              var productId = _invoiceListItems[i].find((e) => e.fieldName === 'Product:ProductId').value
              var stockId = _invoiceListItems[i].find((e) => e.fieldName === 'Product:ProductStockId').value
              postObj.push({
                id: parseInt(rowId),
                count: parseInt(count),
                unitPrice: parseInt(unitPrice),
                discount: parseInt(discount),
                productId: parseInt(productId),
                stockId: parseInt(stockId),
                propItems: null,
              })
            }
            const selectedCustomer = this.$store.state.searchCombo.selectedCustomer
            const selectedCompany = this.$store.state.searchCombo.selectedCompany
            const editInvoiceData = {
              id: this.$route.params.id,
              invoiceNumber: this.invoiceNumber,
              invoiceType: this.isFormal ? 1 : 2,
              buyerId: selectedCustomer == null ? this.CustomerId : selectedCustomer.key,
              companyId: selectedCompany == null ? this.companyId : selectedCompany.key,
              invoiceDate: moment(this.invoiceDate).format(),
              paymentDate: this.invoicePayDate == '' ? null : moment(this.invoicePayDate).format(),
              description: this.description,
              note: this.note,
              shippingCost: Number(this.shippmentPrice),
              editedInvoiceItem: postObj,
              editedInvoiceImage: this.images,
              invoiceImageActionInfo: {
                removedItemsIds: this.removedImages,
              },
              invoiceItemActionInfo: {
                editedItemsIds: this.editedInvoiceItems,
                removedItemsIds: this.deletedInvoiceItems,
              },
            }
            this.allowSubmit = false
            invoiceDataProvider
              .editInvoice(editInvoiceData)
              .then((res) => {
                this.$router.push({
                  path: '/list/invoice',
                })
                this.companyLoading = false
              })
              .catch((err) => {
                this.allowSubmit = true
                this.companyLoading = false
                this.showServerErrorToast(err.response.status)
              })
          } else {
            window.alert('آیتمی تعیر نکرده است')
          }
        }
      }
    },
    addImageToListOfImages(payload) {
      this.mainCropperLoading = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then((res) => {
          this.mainCropperLoading = false
          this.$bvModal.hide('cropperModal')
          this.images.push({ url: res.data.data.downloadUrl, id: 0 })
        })
    },
    removeImage(payload) {
      this.images.splice(payload.index, 1)
      this.removedImages.push(payload.source.id)
    },
    backToFactor(event) {
      this.addCustomerComponent = event
    },
    openCustomerModal() {
      this.CustomerName = ''
      this.agentName = null
      this.addCustomerComponent = true
    },
    openCompanyModal() {
      this.companyName = null
      this.modalCompany = true
    },
    getCustomer(paginationData, type) {
      this.$nextTick(() => {
        invoiceDataProvider
          .getCustomer(paginationData)
          .then((res) => {
            if (type === 1) {
              this.setCustomersList(res.data.data.people)
            } else if (type === 2) {
              this.setSearchedCustomersList(res.data.data.people)
            } else if (type === 3) {
              this.setPaginationCustomersList(res.data.data.people)
            }
          })
          .catch((err) => {})
      })
    },
    loadMoreCustomerData() {
      if (this.customersList.length <= this.customerPagination.pageNumber) {
        this.forceUpdateFlag = false
        this.$nextTick(() => {
          this.getCustomer(this.customerPagination, 1)
          this.forceUpdateFlag = true
        })
      } else {
        this.customerPagination.pageNumber++
        this.forceUpdateFlag = false
        this.$nextTick(() => {
          this.forceUpdateFlag = true
          this.getCustomer(this.customerPagination, 3)
        })
      }
    },
    loadMoreCompanyData() {
      if (this.companyList.length <= this.companyPagination.pageSize) {
        this.forceUpdateFlag = false
        this.$nextTick(() => {
          this.forceUpdateFlag = true
          this.getCompanies(this.companyPagination, 1)
        })
      } else {
        this.companyPagination.pageNumber++
        this.forceUpdateFlag = false
        this.$nextTick(() => {
          this.getCompanies(this.companyPagination, 3)
          this.forceUpdateFlag = true
        })
      }
    },
    searchCustomer(searchedValue) {
      this.customerPagination.keyword = searchedValue
      this.customerPagination.pageNumber = 1
      setTimeout(() => {
        this.getCustomer(this.customerPagination, 2)
      }, 500)
    },
    createNewDetail() {
      const data = {
        productId: 0,
        count: 0,
        unitPrice: 0,
        discount: 0,
      }
      this.setNewDetail(data)
    },
    selectCustomer(customer) {
      this.$store.commit(`searchCombo/SET_SELECTED_CUSTOMER`, customer)

      if (customer) {
        this.CustomerName = customer.value
      }
    },
    cancelAddProduct() {
      this.addProductErrors.imgError = false
      this.addProductErrors.titleError = false
      this.addProductErrors.priceError = false
      this.addProductErrors.countError = false
      this.addProductErrors.descError = false
      this.addProductErrors.adjError = false
    },
    addProduct() {
      this.cancelAddProduct()
      this.propertiesArray = []
      for (let i = 0; i < this.properties.length; i++) {
        this.propertiesArray.push({
          name: this.propertykeys[i],
          value: this.propertyValues[i],
        })
      }

      if (this.addDetailData.img.length <= 0) {
        this.addProductErrors.imgError = true
      }
      if (this.addDetailData.title.length <= 0) {
        this.addProductErrors.titleError = true
      }
      if (!this.priceNewProduct) {
        this.addProductErrors.priceError = true
      }
      if (this.addDetailData.count <= 0) {
        this.addProductErrors.countError = true
      }
      if (this.addDetailData.description.length <= 0) {
        this.addProductErrors.descError = true
      }
      if ((this.propertykeys.length >= 0 && this.propertyValues.length >= 0) || (this.propertykeys.length <= 0 && this.propertyValues.length <= 0)) {
        this.addProductErrors.adjError = true
      }
      if (this.propertykeys.length !== this.propertyValues.length) {
        this.addProductErrors.adjError = true
        return
      } else {
        if (
          this.addDetailData.img.length >= 0 &&
          this.addDetailData.title.length >= 0 &&
          this.priceNewProduct &&
          this.addDetailData.count >= 0 &&
          this.addDetailData.description.length >= 0 &&
          this.propertykeys.length >= 0 &&
          this.propertyValues.length >= 0
        ) {
          const _data = {
            isAvailable: true,
            categoryId: 3,
            brandId: 1,
            name: this.addDetailData.title,
            image: this.addDetailData.img,
            description: this.addDetailData.description,
            stocksItems: [
              {
                count: Number(this.addDetailData.count),
                price: this.priceNewProduct.split(',').join(''),
              },
            ],
            technicalPropertiesDto: this.propertiesArray,
          }
          this.productLoading = true
          if (this.allowProductSubmit) {
            this.allowProductSubmit = false
            invoiceDataProvider
              .addProduct(_data)
              .then((res) => {
                this.setUpdateProductList(true)
                this.productLoading = false
                this.closeAddProductModal()
              })
              .catch((err) => {
                this.productLoading = false
                this.showServerErrorToast(err.response.status)
              })
          }
        }
      }
    },
    closeAddProductModal() {
      this.modal.detail = false
      this.cancelAddProduct()
      this.propertiesArray = []
      this.propertykeys = []
      this.propertyValues = []
      this.dommyNumber = 0
      this.properties = [0]
      this.addDetailData.img = ''
      this.addDetailData.title = ''
      this.addDetailData.price = null
      this.priceNewProduct = null
      this.addDetailData.count = ''
      this.addDetailData.description = ''
      this.addDetailData.titleCategory = ''
      this.addDetailData.category = ''
      this.addDetailData.isActive = true
      this.allowProductSubmit = true
      this.productLoading = false
    },
    getInvoiceData(id) {
      invoiceDataProvider
        .getInvoiceDataWithId({ invoiceId: id })
        .then((res) => {
          this.setInvoiceDefaults(res.data.data)
          for (let i = 0; i < res.data.data.invoiceItemTableData.rows.length; i++) {
            this.setInvoiceList(res.data.data.invoiceItemTableData.rows[i])
          }
          let formal = res.data.data.invoiceType === 1 ? true : false
          this.setIsFormal(formal)
          this.description = res.data.data.description
          this.invoiceDate = res.data.data.invoiceDate
          this.invoicePayDate = res.data.data.paymentDate != null ? res.data.data.paymentDate : ''
          this.note = res.data.data.note
          this.CustomerName = res.data.data.buyer.firstName + ' ' + res.data.data.buyer.lastName
          this.CustomerId = res.data.data.buyer.peopleId
          this.setSelectedCustomer({ key: this.CustomerId, value: this.CustomerName })
          this.invoiceNumber = res.data.data.invoiceNumber
          this.images = res.data.data.image
          if (this.isFormal) {
            this.companyName = res.data.data.buyer.company.name
            this.companyId = res.data.data.buyer.company.id
            this.selectCompany({ key: this.companyId, value: this.companyName })
          }
        })
        .catch((err) => {})
    },
    selectAgent(agent) {
      this.agentName = agent.value
      this.setSelectedAgent(agent)
    },
    getCompanies(paginationData, type) {
      invoiceDataProvider
        .getCompanies(paginationData)
        .then((res) => {
          if (type === 1) {
            this.setCompanyList(res.data.data)
          } else if (type === 2) {
            this.setSearchedCompanyList(res.data.data)
          } else if (type === 3) {
            this.setPaginationCompanyList(res.data.data)
          }
        })
        .catch((err) => {})
    },
    searchCompany(searchedValue) {
      this.companyPagination.keyword = searchedValue
      this.companyPagination.pageNumber = 1
      setTimeout(() => {
        this.getCompanies(this.companyPagination, 2)
      }, 500)
    },
    selectCompany(company) {
      this.$store.commit(`searchCombo/SET_SELECTED_COMPANY`, company)
      this.companyName = company.value
      this.agentPagination.companyId = company.key
    },
    productImage(event) {
      this.cropperLoading = true
      this.imageCropperModal = true
      const selectedImage = event
      fileMannager
        .addImage({ base64image: selectedImage })
        .then((res) => {
          this.cropperLoading = false
          this.imageCropperModal = false
          this.addDetailData.img = res.data.data.downloadUrl
        })
        .catch((err) => {
          alert('مجددا تلاش کنید.')
        })
    },
    flushErrorFlags() {
      this.invoiceNumberError = false
      this.invoiceNoteError = false
    },
    showServerErrorToast(data) {
      if (data.toString().slice(0, 1) == 5) {
        this.toastText = 'مشکلی از سمت سرور پیش آمده لطفا دوباره سعی کنید.'
        this.toastMode = true
        this.showToast = true
        setTimeout(() => {
          this.toastText = null
          this.toastMode = null
          this.showToast = null
        }, 2002)
      }
    },
  },
  watch: {
    eybaba(val) {
      if (val === true) {
        this.customerPagination.pageNumber = 1
        this.getCustomer(this.customerPagination, 1)
        this.updateCustomerList(false)
      }
    },
    customersList(val) {},

    '$route.query.params.id'() {
      this.flushCustomerState()
    },
    modalCompany(val) {
      if (val == false) {
        this.flushCreateCompany()
      }
    },
  },
  beforeMount() {
    this.flushInvoiceList()

    this.getCustomer(this.customerPagination, 1)

    setTimeout(() => {
      this.getCompanies(this.companyPagination, 1)
    }, 100)
    this.initial = this.$route.params.id ? true : false
    if (this.initial) {
      this.showPage = false
      setTimeout(() => {
        this.getInvoiceData(this.$route.params.id)
      }, 2000)
    }

    this.showPage = true
  },
  mounted() {},
  destroyed() {
    this.setIsFormal(true)
    this.flushEverything()
    this.$store.commit(`searchCombo/SET_SELECTED_CUSTOMER`, null)
    this.$store.commit(`searchCombo/SET_SELECTED_COMPANY`, null)
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
